export type ManualAssignResult = 'Ok' | 'NotFound' | 'NotStaffed';

export enum TaskOrder {
    Voice = 1,
    Webchat = 2,
    Messaging = 3,
    Email = 4,
    Unknown = 5,
}
